import { type RadioProps } from './Radio.typed';
import * as Styled from './Radio.styled';
import React from 'react';

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  (props, ref) => {
    return (
      <Styled.Wrapper>
        <input ref={ref} type="radio" {...props} />
        <Styled.Radio />
      </Styled.Wrapper>
    );
  },
);

export default Radio;
